import * as tmaSdk from "@tma.js/sdk";
import vailcode from "@utils/errcode";
import axios from "axios";
import { localhost } from "viem/chains";
import Vue from "vue";
let upLoadImgCount = 1;
let refCode = null;
export default {
  namespaced: true,
  state: {
    userInfo: null,
    botInfo: null,
    token: null,
    etherUSD: null, //美元价格
    web3Data: {
      balance: null,
      platformTotalPower: null,
      myPower: null,
      myRefPower: null,
      pending: null,
      myStake: null,
      platformTotalStake: null,
      myMaspBalance: null,
      poolStarted: null,
      rewPerBlock: null,
      rpc: null,
    },
  },
  mutations: {
    setRpc: (state, payload) => {
      state.rpc = payload;
    },
    setWeb3Data: (state, payload) => {
      for (const key in payload) {
        state.web3Data[key] = payload[key];
        // Vue.set(state.web3Info, key, payload[key]);
      }
    },

    setUserInfo: (state, payload) => {
      state.userInfo = payload;
    },
    setBotInfo: (state, payload) => {
      state.botInfo = payload;
    },
    setToken: (state, payload) => {
      state.token = payload;
    },
    setEtherUSD: (state, payload) => {
      state.etherUSD = payload;
    },
  },
  actions: {
    //获取rpc网络
    getChainInfo: async ({ state, commit, dispatch, rootState }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http("chain/info");
        vailcode(
          res,
          () => {
            const data = res.data;
            commit("setEtherUSD", data.ether_usd);
            commit("setRpc", data?.rpc);
            resolve(data.ether_usd);
          },
          () => {
            resolve();
          }
        );
      });
    },
    upLoadImg: ({ state, dispatch }, _files) => {
      return new Promise((resolve, reject) => {
        const fn = (files) => {
          const formData = new FormData();
          formData.append("file", files);
          const token = state.token;
          formData.append("_token", token);
          // 使用axios上传文件
          axios
            .post(`${_v.http_host}token/upload`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(async (response) => {
              let rs = response.data;
              if (rs.code === 401) {
                if (upLoadImgCount <= 3) {
                  upLoadImgCount += 1;
                  await dispatch("getLoginInfo", []);
                  fn(files);
                } else {
                  upLoadImgCount = 1;
                  resolve(rs);
                }
              } else {
                resolve(rs);
              }
            })
            .catch((error) => {
              console.log("error", error);
              resolve();
            });
        };
        fn(_files);
      });
    },
    //获取登录信息
    getLoginInfo: ({ state, commit, dispatch, rootState }, [ref, type]) => {
      return new Promise(async (resolve, reject) => {
        let initData;
        //  获取邀请码
        const urlParams = window.location.search;
        const refMatch = urlParams.match(/[?&]ref=([^&=]+)/);
        refCode = refMatch ? refMatch[1] : null;

        if (ref) {
          refCode = ref;
        } else {
          if (!refCode) {
            const localRefCode = localStorage.getItem("refCode");
            const referralEncode = state.userInfo?.referral_encode;
            if (localRefCode || referralEncode) {
              refCode = localRefCode || referralEncode;
            }
          }
        }
        let params = {};
        if (refCode && type !== "init") {
          params["refCode"] = refCode;
        }
        params["initData"] = initData;
        params["wallet"] = rootState.wallet.address;
        const res = await _v.$http.post("auth/login", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            const referralEncode = data.userInfo?.referral_encode;
            if (data.userInfo.bind === 0 && (referralEncode || refCode)) {
              localStorage.setItem("refCode", referralEncode || refCode);
            } else {
              localStorage.removeItem("refCode");
            }
            commit("setUserInfo", data.userInfo);
            commit("setBotInfo", data.bot);
            commit("setToken", data.userInfo.auth_token);
            resolve(1);
          },
          async (err) => {
            if (err === "refCode") {
              localStorage.removeItem("refCode");
              _v.$toasted.error("Invalid invitation code!");
              await dispatch("getLoginInfo", [null, "init"]);
            } else {
              resolve();
            }
          },
          type
        );
      });
    },

    //发起Token
    launchToken: async ({ state }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("token/create", params);
        vailcode(
          res,
          () => {
            resolve(res.data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //获取代币列表
    getTokenList: async ({ state }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("token/list", params);
        vailcode(
          res,
          async () => {
            if (!res.data) {
              resolve();
              return;
            }
            resolve(res.data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //获取代币详情
    getTokenInfo: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("token/info", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (!data) {
              resolve();
            }
            resolve(data);
          },
          () => {
            resolve(res);
          }
        );
      });
    },
    //获取代币持有人列表
    getTokenHolder: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("token/holder", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (data) {
              resolve(data);
            }
          },
          () => {
            resolve();
          }
        );
      });
    },
    //最新交易列表
    getTradeNewest: async (_) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("trade/newest", {});
        console.log("xxxxxxxxxxxxxxres", res);
        vailcode(
          res,
          async () => {
            const data = res.data;
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //我发布的代币列表
    getMyLaunchToken: async ({ dispatch }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("token/my_launch", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (data) {
              resolve(data);
            }
          },
          async (err) => {
            console.log("errerrerrerrerrerr", err);
            if (err.code === 401) {
              await dispatch("getLoginInfo", []);
              const data = await dispatch("getMyLaunchToken", params);
              resolve(data);
            } else {
              resolve();
            }
          }
        );
      });
    },
    //我参与的代币列表
    getMyToken: async ({ dispatch }, params) => {
      return new Promise(async (resolve, reject) => {
        if (!params.wallet) {
          resolve();
        }
        const res = await _v.$http.post("token/my", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (data) {
              resolve(data);
            }
          },
          async (err) => {
            if (err.code === 401) {
              await dispatch("getLoginInfo", []);
              const data = await dispatch("getMyToken", params);
              resolve(data);
            } else {
              resolve();
            }
          }
        );
      });
    },
    //代币交易记录
    tokenTrande: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("trade/list", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (data) {
              resolve(data);
            }
          },
          () => {
            resolve();
          }
        );
      });
    },
    //代币交易记录图表
    tokenTradeKline: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("trade/kline", params);
        vailcode(
          res,
          async () => {
            const data = res.data;
            if (data) {
              resolve(data);
            }
          },
          () => {
            resolve();
          }
        );
      });
    },
  },
};
